'use client';

import { useEffect, useState } from 'react';
import FormSelect from '@/components/ui/form/FormSelect';

const currentYear = new Date().getFullYear();

const years = Array.from({ length: currentYear - 1900 + 1 }, (_, i) => ({
    value: String(currentYear - i),
    label: `${String(currentYear - i)}年`,
}));

const months = Array.from({ length: 12 }, (_, i) => {
    const num = i + 1;
    const value = String(num).padStart(2, '0');
    return { value: value, label: `${num}月` };
});

function getDaysInMonth(year: number, month: number): { value: string; label: string }[] {
    const lastDate = new Date(year, month, 0).getDate();
    return Array.from({ length: lastDate }, (_, i) => {
        const num = i + 1;
        const value = String(num).padStart(2, '0');
        return { value: value, label: `${num}日` };
    });
}

export type Birthdate = {
    year: string;
    month: string;
    day: string;
};

export function FormSelectBirthdate({
    value,
    onChange,
    className,
}: {
    value: Birthdate;
    onChange: (value: Birthdate) => void;
    className?: string;
}) {
    const [days, setDays] = useState<{ value: string; label: string }[]>([]);

    useEffect(() => {
        if (value.year && value.month) {
            const y = parseInt(value.year, 10);
            const m = parseInt(value.month, 10);
            setDays(getDaysInMonth(y, m));
        } else {
            setDays([]);
        }
    }, [value.year, value.month]);

    const handleYearChange = (year: string) => {
        onChange({ year, month: '', day: '' });
    };

    const handleMonthChange = (month: string) => {
        onChange({ year: value.year, month, day: '' });
    };

    const handleDayChange = (day: string) => {
        onChange({ ...value, day });
    };

    return (
        <>
            <FormSelect
                id="birth_year"
                name="birth_year"
                value={value.year}
                onChange={(e) => handleYearChange(e.target.value)}
                options={[{ value: '', label: '年' }, ...years]}
                className={`w-1/3 ${className ?? ''}`}
            />
            <div className="px-1" />
            <FormSelect
                id="birth_month"
                name="birth_month"
                value={value.month}
                onChange={(e) => handleMonthChange(e.target.value)}
                options={[{ value: '', label: '月' }, ...months]}
                className={`w-1/3 ${className ?? ''}`}
            />
            <div className="px-1" />
            <FormSelect
                id="birth_day"
                name="birth_day"
                value={value.day}
                onChange={(e) => handleDayChange(e.target.value)}
                options={[{ value: '', label: '日' }, ...days]}
                className={`w-1/3 ${className ?? ''}`}
                disabled={!value.year || !value.month}
            />
        </>
    );
}
